import { TagDto } from '@maia/tags';
import { CustomerDto, IClaimEntity, IInsuranceEntity } from '../shared';
import { undefinedOrTransformToDTOCurried } from '@maia/utils';
import { ClaimHandlerDto } from './claim-handler.dto';

export class CreateClaimDto {
  readonly product_guid: string;
  readonly claim_date: string;
  readonly subject: string;

  constructor(params: {
    productGuid: string;
    claim_date: string;
    subject: string;
  }) {
    this.product_guid = params.productGuid;
    this.claim_date = params.claim_date;
    this.subject = params.subject;
  }
}

export class ClaimDto {
  readonly guid: string;
  readonly reference: string;
  readonly description: string | null;
  readonly status: ReturnType<typeof TagDto.getClaimTag>;
  readonly insurance: Pick<
    IInsuranceEntity,
    'guid' | 'reference' | 'title' | 'icon'
  >;
  readonly customer: CustomerDto;
  readonly occurredAt: Date;
  readonly claimedAmount: number;
  readonly claimAmountIndication: number;
  readonly cause: string;
  readonly activity: string | null;
  readonly isEmsProduct: boolean;
  readonly claimHandler: ClaimHandlerDto;

  constructor(claim: IClaimEntity) {
    this.guid = claim.guid;
    this.reference = claim.reference;
    this.description = claim.description;
    this.status = TagDto.getClaimTag(claim.status);
    this.insurance = {
      guid: claim.insurance.guid,
      reference: claim.insurance.reference,
      title: claim.insurance.title,
      icon: claim.insurance.icon,
    };
    this.occurredAt = new Date(claim.occurred_at);
    this.claimedAmount = claim.claimed_amount;
    this.claimAmountIndication = claim.claim_amount_indication;
    this.cause = claim.cause;
    this.activity = claim.activity;
    this.customer = new CustomerDto(claim.customer);
    this.isEmsProduct = claim.ems_product;
    this.claimHandler = new ClaimHandlerDto(claim.claim_handler);
  }
}

export const undefinedOrClaim = undefinedOrTransformToDTOCurried(
  (entity: IClaimEntity) => new ClaimDto(entity),
);
